import React, { useState, forwardRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import FA from 'admin/components/atoms/FontAwesome';
import { showLoadingSpinner, hideLoadingSpinner } from 'admin/actions/loading-spinner';
import { openAlertModal } from 'admin/actions/alert-modal';
import { Button } from 'admin/components/atoms/Buttons';
import Encoding from 'encoding-japanese';

const downloadUrl = (url, fileName) => {
  let link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  link.click();
  (window.URL || window.webkitURL).revokeObjectURL(url);
}

const convertToSJISUrl = (url) => new Promise(async (resolve) => {
  const response = await fetch(url);
  const dataBlob = await response.blob();
  const myReader = new FileReader();
  myReader.addEventListener("loadend", (e) => {
    const data = e.target.result;
    const unicodeList = Encoding.stringToCode(data);
    const encoded = Encoding.convert(unicodeList, 'SJIS');
    const uInt8List = new Uint8Array(encoded);

    const newBlob = new Blob([uInt8List], { type: 'text/csv' });
    const sjisUrl = (window.URL || window.webkitURL).createObjectURL(newBlob);
    resolve(sjisUrl);
  });
  myReader.readAsText(dataBlob);
});

const CSVButton = ({
  fetchData, customDownloadBehaviour, className, fileName, text, disabled, headers, showLoadingSpinner, hideLoadingSpinner, openAlertModal, encoding, withBOM
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const [csvLink, setCsvLink] = useState(<CSVLink
    data={[]}
    filename={fileName}
    headers={headers}
    className="hidden"
    target="_self"
    uFEFF={withBOM}
  />);

  const showErrorAlert = (msg) => openAlertModal({
    body: msg,
    useCancel: false,
  });

  const downloadCsv = async () => {
    showLoadingSpinner();
    setIsDownloading(true);

    try {
      const data = await fetchData();

      const newCsvLink = React.cloneElement(
        csvLink,
        {
          data,
          ref: async (ref) => {
            if (!(ref && ref.link)) return;

            if (encoding === Encodings.utf8) {
              ref.link.click();
              return;
            }

            const url = ref.link.href;
            if (encoding === Encodings.sjis) {
              const sjisUrl = await convertToSJISUrl(url)
              downloadUrl(sjisUrl, fileName);
            }
            
          }
        }
      );
      setCsvLink(newCsvLink);

    } catch (_) {
      showErrorAlert('CSV書き出しに失敗しました');
    } finally {
      setIsDownloading(false);
      hideLoadingSpinner();
    }

  };

  return (<div className={className}>
    <Button
      onClick={() => customDownloadBehaviour?.(downloadCsv) || downloadCsv()}
      disabled={isDownloading || disabled}
      variant="muted-outline"
    >
      <FA style={{ marginRight: '0.5em' }} icon="download" />
      {!!text ? text : 'CSV'}
    </Button>
    {csvLink}
  </div>);
}

const Encodings = {
  utf8: 'utf8',
  sjis: 'sjis',
}

CSVButton.propTypes = {
  fetchData: PropTypes.func,
  customDownloadBehaviour: PropTypes.func,
  headers: PropTypes.arrayOf(PropTypes.any),
  className: PropTypes.string,
  fileName: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  encoding: PropTypes.oneOf([Encodings.utf8, Encodings.sjis]),
  withBOM: PropTypes.bool,
};

CSVButton.defaultProps = {
  className: '',
  fileName: '',
  text: '',
  disabled: false,
  encoding: 'utf8',
  withBOM: true,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showLoadingSpinner,
      hideLoadingSpinner,
      openAlertModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CSVButton);
